import { render } from "./MyOrderDirDown.vue?vue&type=template&id=b6bab316"
import script from "./MyOrderDirDown.vue?vue&type=script&lang=js"
export * from "./MyOrderDirDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__